import { InfoCircleOutlined } from '@ant-design/icons';
import { Tag, Tooltip } from 'antd';

import type { VCC_STATUS } from 'app/typings/core/common/enum/vccStatus';
import type { VccStatus } from 'app/typings/vcc';

import type { VccStatusType } from '../types';

const OFFSET_TOOLTIP = [17, 0];

type CardStatusProps = {
  status: VccStatusType;
  tooltipTextFn?: (status: VccStatus | VCC_STATUS) => string | null;
};

export const CardStatus = ({ status, tooltipTextFn }: CardStatusProps) => {
  const tooltipText = tooltipTextFn?.(status.status) ?? null;

  return (
    <div className="status">
      <Tag color={status.color}>{status.text}</Tag>
      {!!tooltipText && (
        <Tooltip
          align={{ targetOffset: OFFSET_TOOLTIP }}
          title={tooltipText}
          placement="bottomLeft"
        >
          <InfoCircleOutlined />
        </Tooltip>
      )}
    </div>
  );
};
